import React from 'react'
import NewAdInsertion from './SelectFlow'

const SelectAdInsertion = () => {
    return <NewAdInsertion />
}

export default SelectAdInsertion
